import { apiDate } from '@/helpers/general';
import CustomerAutocomplete from '@/platform/common/components/CustomerAutocomplete/CustomerAutocomplete';
import { DashboardLayout } from '@/platform/layouts';
import {
    Button,
    Container,
    Dropdown,
    Form,
    FormGroup,
    Input,
    Modal,
    ModalActions,
    ModalContent,
    ModalHeader,
    Segment,
    Textarea,
} from '@/platform/ui';
import { useForm, usePage } from '@inertiajs/react';

const CreateOrUpdateView = () => {
    const { users, contacts, action, autocomplete_customer } = usePage().props;
    const { data, setData, processing, post, patch, errors, reset } = useForm(
        action || { customer_id: autocomplete_customer?.id || null }
    );

    const handleSubmit = () => {
        if (data.id) {
            patch(`/actions/${data.id}`, {
                preserveScroll: false,
                preserveState: false,
                preserveUrl: false,
                replace: true,
                onSuccess: () => window.history.back(),
            });

            return;
        }

        post('/actions', {
            preserveScroll: false,
            preserveState: false,
            preserveUrl: false,
            replace: true,
            onSuccess: () => window.history.back(),
        });
    };

    const handleCustomerChange = value => {
        reset();

        setData('customer_id', value);
    };

    return (
        <Container fluid>
            <Segment>
                <Modal open={true} onClose={() => window.history.back()}>
                    <ModalHeader>
                        {data?.id ? 'Actie bewerken' : 'Nieuwe actie toevoegen'}
                    </ModalHeader>
                    <ModalContent>
                        <Form>
                            <FormGroup>
                                <CustomerAutocomplete
                                    label='Klant'
                                    onChange={value =>
                                        handleCustomerChange(value)
                                    }
                                    reset={['contacts']}
                                />
                                <Dropdown
                                    label='Medewerker'
                                    required
                                    options={users || []}
                                    value={data?.user_id || ''}
                                    onChange={value =>
                                        setData('user_id', value)
                                    }
                                    error={errors?.user_id}
                                />
                                <Dropdown
                                    label='Terugkoppeling naar'
                                    multiple
                                    options={users || []}
                                    value={data?.feedback_users || []}
                                    onChange={value =>
                                        setData('feedback_users', value)
                                    }
                                />
                                <Dropdown
                                    label='Contactpersoon'
                                    options={contacts || []}
                                    value={data?.contact_id || ''}
                                    onChange={value =>
                                        setData('contact_id', value)
                                    }
                                />
                                <Input
                                    label='Onderwerp'
                                    required
                                    value={data?.subject || ''}
                                    onChange={event =>
                                        setData('subject', event.target.value)
                                    }
                                    error={errors?.subject || ''}
                                />
                                <Textarea
                                    label='Actie'
                                    rows={5}
                                    value={data?.action || ''}
                                    onChange={event =>
                                        setData('action', event.target.value)
                                    }
                                    error={errors?.action || ''}
                                />
                                <Dropdown
                                    label='Status'
                                    options={[
                                        {
                                            id: 0,
                                            name: 'Open',
                                        },
                                        {
                                            id: 3,
                                            name: 'Afgehandeld',
                                        },
                                    ]}
                                    value={data?.status || 0}
                                    onChange={value => setData('status', value)}
                                />
                                <Input
                                    label='Deadline'
                                    type='date'
                                    value={apiDate(data?.deadline) || ''}
                                    onChange={event =>
                                        setData('deadline', event.target.value)
                                    }
                                    error={errors.deadline}
                                />
                            </FormGroup>
                        </Form>
                    </ModalContent>
                    <ModalActions>
                        <Button
                            onClick={() => window.history.back()}
                            type='button'
                        >
                            Annuleren
                        </Button>
                        <Button
                            variant='primary'
                            onClick={handleSubmit}
                            disabled={processing}
                            loading={processing}
                        >
                            Opslaan
                        </Button>
                    </ModalActions>
                </Modal>
            </Segment>
        </Container>
    );
};

CreateOrUpdateView.layout = page => <DashboardLayout>{page}</DashboardLayout>;

export default CreateOrUpdateView;
